import axios from "axios";
import { authHeader } from "./authHeader";

const API_URL = process.env.REACT_APP_API_URL;

// const register = (username, email, password) => {
//   return axios.post(API_URL + "/api/customer/register", {
//     username,
//     email,
//     password,
//   });
// };


const login = async (email,password) => {
  const response = await axios.post(API_URL + "/api/users/login",{
     email,
     password,
    });
  if (response.data.token) {
    localStorage.setItem("user", JSON.stringify(response.data));
    }
  return response.data;
};


const logout = () => {
  localStorage.removeItem("user");
};


const forgotPassword = async (email) => {
    const response = await axios.post(API_URL + "/api/users/forgot-password", {
      email,
    });
    return response.data;  
 
};

//ResetPassword
const resetPassword = async (token,newPassword,confirmPassword) => {
  const response = await axios.post(API_URL + `/api/users/reset-password/${token}`,{newPassword,confirmPassword});
  return response.data;
}


export const getUserProfile= async () => {
  const response = await axios.get(API_URL +'/api/users/profile', { 
      headers: authHeader() });
  
  // console.log("respro:",response)
  return response;
};





// const getCurrentUser = () => {
//   return JSON.parse(localStorage.getItem("user"));
// };





const AuthAPI = {
  // register,
  login,
  logout,
  forgotPassword,
  resetPassword,
  getUserProfile,
  // getCurrentUser,
};

export default AuthAPI;